import { ChangeEvent } from 'react';
import { PageHeaderTitle } from 'components/PageHeaderTitle';
import { SectionType } from 'pages/ClaimsContractsToolPage/types';
import './BookmarksPage.css';
import { useBookmarksData } from './hooks/useBookmarksData';
import { BookmarksFilter } from './sections/BookmarksFilter/BookmarksFilter';
import { BookmarksList } from './sections/BookmarksList/BookmarksList';
import { Layout } from 'components/Layout';

export const BookmarksPage = () => {
  const {
    setSelectedOption,
    filteredBookmarks,
    claimsBookmarksCount,
    contractsBookmarksCount,
    myBookmarksCount,
    matchingBookmarksCount,
    allBookmarksCount,
  } = useBookmarksData(SectionType.NONE);

  return (
    <Layout>
      <div className="bookmarks-page">
        <PageHeaderTitle title="Bookmarks" />
        <div className="bookmarks-page__container">
          <BookmarksFilter
            bookmarksData={{
              claimsBookmarksCount,
              contractsBookmarksCount,
              myBookmarksCount,
              matchingBookmarksCount,
              allBookmarksCount,
              bookmarksCount: filteredBookmarks.length,
            }}
            handleSelectChange={(event: ChangeEvent<HTMLSelectElement>) =>
              setSelectedOption(event.target.value)
            }
          />
          <BookmarksList bookmarks={filteredBookmarks} />
        </div>
      </div>
    </Layout>
  );
};
